import { h } from 'preact';

export default function Error(props: React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={32}
      height={32}
      viewBox="0 0 32 32"
      {...props}
    >
      <path
        d="M16 2c7.72 0 14 6.28 14 14s-6.28 14-14 14S2 23.72 2 16 8.28 2 16 2zm0 26c6.62 0 12-5.38 12-12S22.62 4 16 4 4 9.38 4 16s5.38 12 12 12zm-1-18v8c0 .55.45 1 1 1s1-.45 1-1v-8c0-.55-.45-1-1-1s-1 .45-1 1zm1 13c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
      />
    </svg>
  );
}

